import { useAppState, actions } from "../../../contexts/AppStateContext";
import { useAuth } from "../../../hooks/useAuth";
import { usePostHog } from "posthog-js/react";
import { useNavigation } from "@react-navigation/native";
import { useSetOnboardingStatusMutation } from "../../../graphql/generated/graphql";
import OnboardMenu from "../../../components/onboarding/OnboardMenu/OnboardMenu";
import { useAppConfig } from "../../../AppConfigProvider";

function OnboardMenuContainer() {
  const appConfig = useAppConfig();
  const { dispatch } = useAppState();
  const { logout } = useAuth();
  const posthog = usePostHog();
  const navigation = useNavigation();

  const isCompanionMode = appConfig.isCompanionMode;

  const [setOnboardingStatus] = useSetOnboardingStatusMutation();

  const handleLogoutPress = () => {
    logout();
  };

  const handleSkipPress = async () => {
    posthog?.capture("Onboarding Skipped");
    await setOnboardingStatus({
      variables: {
        isOnboarded: true,
      },
    });

    if (isCompanionMode) {
      navigation.navigate("Companion");
    } else {
      navigation.navigate("Home");
    }

    dispatch({
      type: actions.SET_META,
      payload: { isOnboarded: true },
    });
  };

  return <OnboardMenu onLogout={handleLogoutPress} onSkip={handleSkipPress} />;
}

export default OnboardMenuContainer;
